<template>
  <div class="app-shell">
    <AnnouncementBanner v-if="isAuthenticated" />
    <div class="app-view">
      <RouterView />
    </div>
  </div>
</template>

<script setup lang="ts">
import { RouterView } from "vue-router";
import { useAuth } from "@/stores/auth";
import AnnouncementBanner from "@/components/AnnouncementBanner.vue";

const { isAuthenticated } = useAuth();
</script>

<style scoped>
.app-shell {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  overflow: hidden;
}

.app-view {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

/* On small screens, unlock the page so content can scroll naturally.
   Chat view (chat-root) overrides this with position:fixed to keep
   the message area + input locked to the viewport. */
@media (max-width: 768px) {
  .app-shell {
    height: auto;
    min-height: 100dvh;
    overflow: visible;
  }
  .app-view {
    overflow: visible;
    min-height: 0;
  }
}
</style>
